<template>
  <q-page>
    <div class="row">
      <div v-if="!$apollo.loading" class="col q-pa-md">
        <template>
          <div>
            <div class="col-12 q-gutter-md text-center">
              <h3>Edit Product</h3>
            </div>      
            <q-splitter
              v-model="splitterModel"
              :limits="[11, 11]"
              disable
            >
              <template v-slot:before>
                <q-tabs
                  v-model="tab"
                  vertical
                  class="text-primary"
                >
                  <q-tab name="attributes" icon="tune" label="Attributes" />
                  <q-tab name="images" icon="image" label="Images" />
                  <q-tab name="details" icon="edit_note" label="Details" />
                </q-tabs>
              </template>

              <template v-slot:after>
                <q-tab-panels
                  v-model="tab"
                  animated
                  vertical
                  transition-prev="jump-up"
                  transition-next="jump-up"
                >
                  <q-tab-panel name="attributes">
                    <div class="col q-gutter-md">
                      <m-edit-item field="name" type="input" graphqlType="Product" :id="id" />
                      <m-edit-item field="description" type="input" input-type="textarea" graphqlType="Product" :id="id" />
                      <m-edit-item field="reference" type="input" input-type="input" graphqlType="Product" :id="id" />
                      <m-edit-item field="attributes" type="list" graphqlType="Product" :id="id" />
                      <div class="row">
                        <div style="margin: 10px 40px">Category:</div>
                        <div style="margin: 0px 10px">
                          <q-radio v-model="category" val="" label="No Category" @input="v => updateAttribute(v)" />
                          <q-radio v-model="category" val="ICP Home Products" label="ICP Home Products" @input="v => updateAttribute(v)"/>
                          <q-radio v-model="category" val="ICP Volumes" label="ICP Volumes" @input="v => updateAttribute(v)"/>
                          <q-radio v-model="category" val="Kids" label="Kids" @input="v => updateAttribute(v)"/>
                        </div>
                      </div>
                      <div class="row">

                        <h4>{{product.skus.length}} Skus</h4>

                        <q-space/>
                        <q-input dense debounce="300" color="primary" v-model="skuFilter">
                          <template v-slot:append>
                            <q-icon name="search" />
                          </template>
                        </q-input>
                      </div>

                      <div class="row">
                        <div v-if="product.skus.length > 0" class="col-3">
                          <q-btn>Set stock price for all SKUs</q-btn>
                          <m-popup-edit v-model="product.skus[0].price" select-on-focus @save="v => editAllSkus({price: Number(v)})" :buttons="true"/>
                        </div>
                        <div v-if="product.skus.length > 0" class="col-3">
                          <q-btn>Set container price for all SKUs</q-btn>
                          <m-popup-edit v-model="product.skus[0].containerPrice" select-on-focus @save="v => editAllSkus({containerPrice: Number(v)})" :buttons="true"/>
                        </div>

                        <div v-if="product.skus.length > 0" class="col-3">
                          <q-btn>Set retail price for all SKUs</q-btn>
                          <m-popup-edit v-model="product.skus[0].retailPrice" select-on-focus @save="v => editAllSkus({retailPrice: Number(v)})" :buttons="true"/>
                        </div>

                        <div v-if="product.skus.length > 0" class="col-3">
                          <q-btn color="primary">Set container price for all SKUs, Stock, 10%+ Retail</q-btn>
                          <m-popup-edit v-model="product.skus[0].containerPrice" select-on-focus @save="v => editAllSkus({containerPrice: Number(v), price: Number(v), retailPrice: Number(v)*1.1})" :buttons="true"/>
                        </div>
                      </div>

                      <q-table
                        class="q-mt-none"
                        :data="filteredSkus"
                        :columns="skuColumns"
                        dense
                        hide-bottom
                        :pagination.sync="skuTablePagination"
                        binary-state-sort
                        row-key="id">

                        <template v-slot:body="props">
                          <q-tr :props="props">
                            <q-td key="add" :props="props">
                              <q-btn dense size="xs" label="Add Item" outline @click="dialogCreateITU(props.row)" style="height:15px;" />
                            </q-td>     

                            <q-td key="colour" :props="props">
                              <span @click="editSkuColour(props.row)">
                                <div :style="{border: '1px silver solid', backgroundColor: props.row.options.colour.hex, width: '10px',height: '10px'}" class="inline-block"></div>
                                {{props.row.options.colour.group}} - {{props.row.options.colour.name}}
                              </span>
                              <q-btn flat dense icon="gesture" size="xs" @click="createNewSkuColour(props.row)"/>
                            </q-td>

                            <q-td key="price" :props="props">
                              {{formatCurrency(props.row.price)}}
                              <m-popup-edit v-model="props.row.price" select-on-focus @save="v => editSku(props.row.id, {price: Number(v)})" :buttons="false"/>
                            </q-td>

                            <q-td key="containerPrice" :props="props">
                              {{formatCurrency(props.row.containerPrice)}}
                              <m-popup-edit v-model="props.row.containerPrice" select-on-focus @save="v => editSku(props.row.id, {containerPrice: Number(v)})" :buttons="false"/>
                            </q-td>

                            <q-td key="retailPrice" :props="props">
                              {{formatCurrency(props.row.retailPrice)}}
                              <m-popup-edit v-model="props.row.retailPrice" select-on-focus @save="v => editSku(props.row.id, {retailPrice: Number(v)})" :buttons="false"/>
                            </q-td>

                            <q-td key="stock" :props="props">
                              {{props.row.stock}}
                              <m-popup-edit v-model="props.row.stock" select-on-focus @save="v => editSku(props.row.id, {stock: Number(v)})" :buttons="false"/>
                            </q-td>
                            
                            <q-td key="showInContainer" :props="props">
                              <q-checkbox dense :value="props.row.showInContainer" @input="v => editSku(props.row.id, {showInContainer: v})"></q-checkbox>
                            </q-td>     

                            <q-td key="showInRetail" :props="props">
                              <q-checkbox dense :value="props.row.showInRetail" @input="v => editSku(props.row.id, {showInRetail: v})"></q-checkbox>
                            </q-td>

                            <q-td key="hideInStock" :props="props">
                              <q-checkbox dense :value="props.row.hideInStock||false" @input="v => editSku(props.row.id, {hideInStock: v})"></q-checkbox>
                            </q-td>

                            <q-td key="showPreStock" :props="props">
                              <q-checkbox dense :value="props.row.showPreStock||false" @input="v => editSku(props.row.id, {showPreStock: v})"></q-checkbox>
                            </q-td>

                            <q-td key="preStock" :props="props">
                              {{props.row.preStock||0}}
                              <m-popup-edit v-model="props.row.preStock" select-on-focus @save="v => editSku(props.row.id, {preStock: Number(v)})" :buttons="false"/>
                            </q-td>

                            <q-td key="availableOn" :props="props">
                              {{props.row.availableOn||"-"}}
                              <q-popup-proxy>
                                <q-date v-model="props.row.availableOn" minimal>
                                  <!-- <div class="row items-center justify-end q-gutter-sm"> -->
                                    <!-- <q-btn label="Cancel" color="primary" flat v-close-popup /> -->
                                    <q-btn label="OK" color="primary" flat @click="v => editSku(props.row.id, {availableOn: props.row.availableOn})" v-close-popup/>
                                  <!-- </div> -->
                                </q-date>
                              </q-popup-proxy>
                            </q-td>

                            <q-td key="deleted" :props="props">
                              <div v-if="props.row.deleted" style="width: 60px; border: 1px solid #C5161C;color:#C5161C;border-radius:3px">Deleted</div>
                              <!-- <div v-if="props.value" style="width: 60px; background-color:silver;color:white;border-radius:3px">Active</div> -->
                              <div v-else style="width: 60px; border: 1px solid green;color:green;border-radius:3px">In Use</div>
                              <!-- <q-icon color="red" size="sm" name="auto_delete" v-if="props.value"/> -->
                            </q-td>
                          </q-tr>

                          <q-tr v-if="props.row.itus.length">
                            <q-td colspan="100%">
                              <div class="q-pa-sm">
                                <q-table
                                  :data="props.row.itus"
                                  :columns="ituColumns"
                                  dense                   
                                  row-key="name"
                                  binary-state-sort                    
                                >
                                  <template v-slot:body="props">
                                    <q-tr :props="props">
                                      <q-td key="barcode" :props="props"  @input="updateBarcode(props.row)">
                                        {{props.row.barcode}}
                                        <m-popup-edit v-model="props.row.barcode" @save="v => updateBarcode(props.row,v)" :buttons="true"/>                                        
                                      </q-td>

                                      <q-td key="type" :props="props">
                                        <q-select  @input="updateType(props.row)" style="max-width:1px;margin:0;padding:0" item-aligned hide-dropdown-icon hide-bottom-space square dense borderless options-dense v-model="props.row.type" :options="ituTypeOptions" />
                                      </q-td>

                                      <q-td key="status" :props="props" >
                                        <q-select @input="updateStatus(props.row)" item-aligned hide-dropdown-icon hide-bottom-space square dense borderless options-dense v-model="props.row.status" :options="ituStatusOptions" :disable="props.row.status.includes('Assigned')">
                                        </q-select>
                                      </q-td>

                                      <q-td key="paidprice" :props="props">
                                        {{props.row.paidprice}}
                                      </q-td>

                                      <q-td key="weight" :props="props">
                                        {{props.row.weight}}
                                      </q-td>

                                      <q-td key="createdAt" :props="props">
                                        {{formatDateTime(props.row.createdAt)}}
                                      </q-td>

                                      <q-td key="updatedAt" :props="props">
                                        {{formatDateTime(props.row.updatedAt)}}
                                      </q-td>
                                      
                                      <q-td key="actions" :props="props">
                                        <q-btn size="sm" dense flat color="blue" icon="history">
                                          <q-tooltip>View Item History</q-tooltip>
                                        </q-btn>
                                        <q-btn size="sm" dense flat color="blue" icon="inventory">
                                          <q-tooltip>Assign Item to Order</q-tooltip>
                                        </q-btn>                                                            
                                        <q-btn size="sm" dense flat color="primary" icon="delete">
                                          <q-tooltip>Delete Item</q-tooltip>
                                        </q-btn>                              
                                      </q-td>                                  
                                    </q-tr>
                                  </template>
                                </q-table>
                              </div>
                            </q-td>
                          </q-tr>


                          <!-- <q-tr v-for="(itu,i) in props.row.itus" :props="props">
                            <q-td colspan="100%" >
                              {{itu.bar}}
                            </q-td>
                            </q-tr>               -->
                        </template>
                        <template v-slot:bottom-row>
                          <q-tr>
                            <q-td colspan="100%">
                              <q-btn dense flat icon="add" class="full-width" @click="addSku">Add New Sku</q-btn>
                            </q-td>
                          </q-tr>
                        </template>            
                      </q-table>
                    </div>                    
                  </q-tab-panel>

                  <q-tab-panel name="images">
                    <div>
                      <div class="row q-col-gutter justify-center">
                        <q-card v-for="(image, i) in product.images" :key="i" class="col-3 q-ma-lg column">
                          <q-img :src="image.url" contain/>
                          <q-space/>
                          <q-card-section class="col-auto">
                            <q-input debounce="1000" :value="image.url" @input="v => updateImage(image.url, v)"/>
                          </q-card-section>
                          <q-card-section class="col-auto">
                            <q-btn flat dense icon="delete" @click="deleteImage(image.url)" />
                          </q-card-section>
                        </q-card>
                        <q-card class="col-auto q-ma-lg row justify-center vertical-middle col-3">
                          <q-btn flat class="col q-px-xl" icon="add" @click="newImageDialogShowing=true">Add New Image</q-btn>
                        </q-card>
                      </div>
                    </div>
                  </q-tab-panel>

                  <q-tab-panel name="details">
                      <q-page-sticky style="z-index:9999" position="bottom-right" :offset="[25, 25]">
                        <q-btn color="primary" label="Update" @click="updatePD" v-if="pdLoaded"/> 
                        <q-btn color="primary" label="Save" @click="addPD" v-else/>
                      </q-page-sticky>
                      <q-card style="margin-top:20px">
                        <q-card-section>
                          <div style="font-size:22px;">Product Details Page</div>
                        </q-card-section>
                        <q-separator />
                        <q-card-section>
                          <div id="input_set_component">
                            <div style="margin-top:20px">
                              <div style="display:inline; font-size:16px; ">Subtitle (Short Description)</div>
                              <div style="display:inline; float:right">
                                <q-checkbox dense left-label v-model="productDetails.basic_details.show_subtitle" label="Show" />
                              </div>
                            </div>
                            <div>
                              <q-input bg-color="grey-2" outlined dense v-model="productDetails.basic_details.subtitle" type="text" />
                            </div>
                          </div>
                          <div>
                            <div style="margin-top:20px">
                              <div style="display:inline; font-size:16px; ">Stock Message</div>
                              <div style="display:inline; float:right">
                                <q-checkbox dense left-label v-model="productDetails.basic_details.options.show_stock_message" label="Show" />
                              </div>
                            </div>
                            <div>
                              <q-input bg-color="grey-2" outlined dense v-model="productDetails.basic_details.stock_message" type="text" />
                            </div>
                          </div>
                          <div id="input_set_component">
                            <div style="margin-top:20px">
                              <div style="font-size:16px;">Options</div>
                              <div style="margin: 10px" >
                                <div style="display:block"><q-checkbox dense v-model="productDetails.basic_details.options.show_status_tag" label="Show 'New' Tag" /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.basic_details.options.show_rating_stars" label="Show ranking (Stars)" /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.basic_details.options.show_whishing_btn" label="Show 'Add to Whishing List' button" /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.basic_details.options.show_fullscreen_btn" label="Show 'Fullscreen' button on images" /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.basic_details.options.autoplay_gallery" label="Autoplay images" /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.basic_details.options.show_qty_colour" label="Show quantities inside colour selector" /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.basic_details.options.show_stock_message" label="Show Stock Message"/></div>
                              </div>
                            </div>
                          </div>
                        </q-card-section>
                      </q-card>

                      <q-card style="margin-top:20px">
                        <q-card-section>
                          <div style="font-size:22px; display:inline">Features Panel</div>
                          <div style="display:inline; float:right">
                            <q-checkbox dense left-label v-model="productDetails.feature_panel.show" label="Show Panel" />
                          </div>
                        </q-card-section>
                        <q-separator />
                        <q-card-section>
                          <div id="panel_standard">  
                            <div class="text-right">
                              <q-toggle v-model="show_editor" color="primary" label="Show Editor" left-label />
                            </div>
                            <div>
                              <!-- EDITOR -->
                              <div v-if="show_editor" class="q-pa-md q-gutter-sm">
                                <q-editor
                                  v-model="productDetails.feature_panel.content"
                                  :dense="$q.screen.lt.md"
                                  :toolbar="[
                                  [
                                  {
                                  label: $q.lang.editor.align,
                                  icon: $q.iconSet.editor.align,
                                  fixedLabel: true,
                                  list: 'only-icons',
                                  options: ['left', 'center', 'right', 'justify']
                                  },
                                  {
                                  label: $q.lang.editor.align,
                                  icon: $q.iconSet.editor.align,
                                  fixedLabel: true,
                                  options: ['left', 'center', 'right', 'justify']
                                  }
                                  ],
                                  ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                                  ['token', 'hr', 'link', 'custom_btn'],
                                  ['print', 'fullscreen'],
                                  [
                                  {
                                  label: $q.lang.editor.formatting,
                                  icon: $q.iconSet.editor.formatting,
                                  list: 'no-icons',
                                  options: [
                                  'p',
                                  'h1',
                                  'h2',
                                  'h3',
                                  'h4',
                                  'h5',
                                  'h6',
                                  'code'
                                  ]
                                  },
                                  {
                                  label: $q.lang.editor.fontSize,
                                  icon: $q.iconSet.editor.fontSize,
                                  fixedLabel: true,
                                  fixedIcon: true,
                                  list: 'no-icons',
                                  options: [
                                  'size-1',
                                  'size-2',
                                  'size-3',
                                  'size-4',
                                  'size-5',
                                  'size-6',
                                  'size-7'
                                  ]
                                  },
                                  {
                                  label: $q.lang.editor.defaultFont,
                                  icon: $q.iconSet.editor.font,
                                  fixedIcon: true,
                                  list: 'no-icons',
                                  options: [
                                  'default_font',
                                  'arial',
                                  'arial_black',
                                  'comic_sans',
                                  'courier_new',
                                  'impact',
                                  'lucida_grande',
                                  'times_new_roman',
                                  'verdana'
                                  ]
                                  },
                                  'removeFormat'
                                  ],
                                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                                  ['undo', 'redo'],
                                  ['viewsource']
                                  ]"
                                  :fonts="{
                                  arial: 'Arial',
                                  arial_black: 'Arial Black',
                                  comic_sans: 'Comic Sans MS',
                                  courier_new: 'Courier New',
                                  impact: 'Impact',
                                  lucida_grande: 'Lucida Grande',
                                  times_new_roman: 'Times New Roman',
                                  verdana: 'Verdana'
                                  }"
                                  />
                              </div>
                              <!-- END EDITOR -->
                              <!-- PREVIEW -->
                              <div style="font-size:16px; ">Preview</div>
                              <div style="margin: 15px; border: 1px solid grey; min-height:100px">
                                <component :is="previewFeatures"/>
                              </div>
                              <!-- END PREV -->
                            </div>
                          </div>
                        </q-card-section>
                      </q-card>

                      <q-card style="margin-top:20px">
                        <q-card-section>
                          <div style="font-size:22px; display:inline">Technical Details Panel</div>
                          <div style="display:inline; float:right">
                            <q-checkbox dense left-label v-model="productDetails.technical_details_panel.show" label="Show Panel" />
                          </div>
                        </q-card-section>
                        <q-separator />
                        <q-card-section>
                          <div id="panel_standard">  
                            <div class="text-right">      
                              <q-toggle v-model="show_editor2" color="primary" label="Show Editor" left-label />
                            </div>
                            <div>
                              <!-- XXXX -->
                              <div v-if="show_editor2" class="q-pa-md q-gutter-sm">
                                <q-editor
                                  v-model="productDetails.technical_details_panel.content"
                                  :dense="$q.screen.lt.md"
                                  :toolbar="[
                                  [
                                  {
                                  label: $q.lang.editor.align,
                                  icon: $q.iconSet.editor.align,
                                  fixedLabel: true,
                                  list: 'only-icons',
                                  options: ['left', 'center', 'right', 'justify']
                                  },
                                  {
                                  label: $q.lang.editor.align,
                                  icon: $q.iconSet.editor.align,
                                  fixedLabel: true,
                                  options: ['left', 'center', 'right', 'justify']
                                  }
                                  ],
                                  ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                                  ['token', 'hr', 'link', 'custom_btn'],
                                  ['print', 'fullscreen'],
                                  [
                                  {
                                  label: $q.lang.editor.formatting,
                                  icon: $q.iconSet.editor.formatting,
                                  list: 'no-icons',
                                  options: [
                                  'p',
                                  'h1',
                                  'h2',
                                  'h3',
                                  'h4',
                                  'h5',
                                  'h6',
                                  'code'
                                  ]
                                  },
                                  {
                                  label: $q.lang.editor.fontSize,
                                  icon: $q.iconSet.editor.fontSize,
                                  fixedLabel: true,
                                  fixedIcon: true,
                                  list: 'no-icons',
                                  options: [
                                  'size-1',
                                  'size-2',
                                  'size-3',
                                  'size-4',
                                  'size-5',
                                  'size-6',
                                  'size-7'
                                  ]
                                  },
                                  {
                                  label: $q.lang.editor.defaultFont,
                                  icon: $q.iconSet.editor.font,
                                  fixedIcon: true,
                                  list: 'no-icons',
                                  options: [
                                  'default_font',
                                  'arial',
                                  'arial_black',
                                  'comic_sans',
                                  'courier_new',
                                  'impact',
                                  'lucida_grande',
                                  'times_new_roman',
                                  'verdana'
                                  ]
                                  },
                                  'removeFormat'
                                  ],
                                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                                  ['undo', 'redo'],
                                  ['viewsource']
                                  ]"
                                  :fonts="{
                                  arial: 'Arial',
                                  arial_black: 'Arial Black',
                                  comic_sans: 'Comic Sans MS',
                                  courier_new: 'Courier New',
                                  impact: 'Impact',
                                  lucida_grande: 'Lucida Grande',
                                  times_new_roman: 'Times New Roman',
                                  verdana: 'Verdana'
                                  }"
                                  />
                              </div>
                              <!-- END XXXX -->
                              <!-- PREVIEW -->
                              <div style="font-size:16px; ">Preview</div>
                              <div style="margin: 15px; border: 1px solid grey; min-height:100px">
                                <component :is="previewTechnicalDetails"/>
                              </div>
                              <!-- END PREV -->
                            </div>
                          </div>
                        </q-card-section>
                      </q-card>

                      <q-card style="margin-top:20px">
                        <q-card-section>
                          <div style="font-size:22px; display:inline">Rating and Review Panel</div>
                          <div style="display:inline; float:right">
                            <q-checkbox dense left-label v-model="productDetails.review_panel.show" label="Show Panel" />
                          </div>
                        </q-card-section>
                        <q-separator />
                        <q-card-section>
                          <div id="input_set_component">
                            <div style="margin-top:20px">
                              <div style="margin: 10px" >
                                <div style="display:block"><q-checkbox dense v-model="productDetails.review_panel.show_rating_breakdown" label="Show 'Rating Breakdown' subpanel" /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.review_panel.show_product_recomendation_subpanel" label="Show 'Product Recomendation' subpanel " /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.review_panel.show_write_btn" label="Show 'Write a Review' button" /></div>
                                <div style="display:block"><q-checkbox dense v-model="productDetails.review_panel.show_helpful_line" label="Show 'Helpful' line on individual reviews" /></div>
                              </div>
                            </div>
                          </div>
                        </q-card-section>
                      </q-card>
                  </q-tab-panel>
                </q-tab-panels>
              </template>
            </q-splitter>
          </div>
        </template>
      </div>
    </div>
    <q-dialog v-model="newImageDialogShowing">
      <q-card class="column">
        <q-uploader
          :factory="uploaderFactory"
          label="Upload Nes Image"
          :max-file-size="20000000"
          accept=".jpg,.jpeg,.png,.gif"
          auto-upload
          hide-upload-btn
          style="max-width: 300px"
        />
        <q-btn @click="addNewImage('')" flat class="justify-center">Don't Upload An Image</q-btn>
      </q-card>
    </q-dialog>
    <q-dialog v-model="showCreateITU">
      <q-card flat bordered class="my-card bg-grey-1">
        <div class="text-h6 text-center">Add ITU</div>
        <q-separator />
        <q-card-section>
          <div class="row items-center no-wrap">
            <div class="col">
              <q-input @input="v => formatBarcode(v)" dense outlined v-model="newBarcode" label="Barcode" debounce="1000" />
              <q-select hide-bottom-space dense outlined options-dense v-model="newType" :options="ituTypeOptions" label="Type"/>
              <q-select hide-bottom-space dense outlined options-dense v-model="newStatus" :options="ituStatusOptions" label="Status"/>
              <q-input dense outlined v-model="newWeight" label="Weight"/>
              <q-input dense outlined v-model="newPaidPrice" label="Paid Price"/>
              <q-separator spaced/>
              <q-checkbox dense v-model="addQty" label="Add +1 to Quantity" /><br>
              <q-checkbox dense v-model="setForSale" label="Set Item for Sale" />
              <div v-if="addITUerror" class="row" style="background-color:mistyrose; padding: 5px; border-radius: 5px;  margin-top: 5px; border: solid 1px red">{{addITUerror}}</div>
            </div>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-actions>
          <q-btn flat outline @click="addITU;showCreateITU = false">Create & Close</q-btn>
          <q-btn flat @click="addITU">Create</q-btn>
        </q-card-actions>
      </q-card>      
    </q-dialog>    
<!--    <q-card v-for="sku in filteredSkus" v-bind:key="sku.id" class="q-pa-md">-->
<!--      <m-edit-item field="options" type="list" graphqlType="Sku" :id="sku.id" />-->
<!--      <m-edit-item field="price" type="input" graphqlType="Sku" input-type="number" :id="sku.id" />-->
<!--      <m-edit-item field="stock" type="input" graphqlType="Sku" input-type="number" :id="sku.id" />-->
<!--      <m-edit-item field="containerPrice" type="input" graphqlType="Sku" input-type="number" :id="sku.id" />-->
<!--      <m-edit-item field="showInContainer" type="checkbox" graphqlType="Sku" :id="sku.id" />-->
<!--      <q-btn icon="delete" class="q-mt-md" @click="deleteSku(sku)">Delete Sku</q-btn>-->
<!--    </q-card>-->

<!--    <colour-select-dialog :value="colourSelectDialogShowing"></colour-select-dialog>-->
  </q-page>
</template>

<script>
import gql from 'graphql-tag'
import MEditItem from '../../components/ui/admin/MEditItem'
import adminNotifyError from '../../util/adminNotifyError'
import { formatCurrency, formatDateTime, properCase } from '../../util/string'
import MPopupEdit from '../../components/ui/MPopupEdit'
import ColourSelectDialog from '../../components/ColourSelectDialog'



export default {
  name: 'Product',
  components: { MPopupEdit, MEditItem },
  apollo: {
    product () {
      return {
        query: gql`query product ($id: ID!) {
          product (id: $id) {
            id
            name
            description
            reference
            images {
              url
              name
            }
            attributes
            urlSlug
            skus {
              id
              attributes
              barcode
              options
              price
              containerPrice
              retailPrice
              showInContainer
              showInRetail
              hideInStock
              showPreStock
              preStock
              availableOn
              stock
              colour
              deleted
              itus{
                id
                barcode
                paidPrice
                type
                status
                weight
                createdAt
                updatedAt
              }
            }
          }
        }
        `,
        variables: {
          id: this.$route.params.id
        }
      }
    }
  },
  data () {
    return {
      category:"",
      showing: false,
      tab: "attributes",
      splitterModel: 10,
      formatCurrency: formatCurrency,
      formatDateTime: formatDateTime,
      properCase: properCase,
      show_editor:false,
      show_editor2:false,
      show_editor3:false,

      productName:"",
      subtitle:"",
      show_subtitle:true,
      show_description:true,
      description:"",
      opt_show_tag:true,
      opt_show_rating:true,
      opt_show_whishing_btn:true,
      opt_show_fullscreen:true,
      opt_autoplay_images:true,
      opt_show_qty_colour:true,
      opt_show_stock_message: true,

      show_features:true,
      features_content:"",
      show_td:true,
      td_content:"",
      show_reviews:true,
      rev_show_rating_breakdown:true,
      rev_show_product_recomendation_subpanel:true,
      rev_show_write_btn:true,
      rev_show_helpful_line:true,

      reference:"",
      barcode:"",
      type:"",
      brand:"",
      pdLoaded: false,

      addQty: true,
      setForSale: true,
      addITUerror:"",
      newBarcode:"",
      newStatus:"available",
      newType:"in-stock",
      newWeight:"",
      newPaidPrice:"",
      showCreateITU: false,
      selectedSKU: "",
      colourSelectDialogShowing: true,
      newImageDialogShowing: false,
      skuTablePagination: { rowsPerPage: 0 },
      skuFilter: '',
      ituStatusOptions: ['available','reserved','removed','missing parts', 'damaged','barcode voided'],
      ituTypeOptions: ['in-stock','pre-stock'],
      //Product Details
      productDetails:{
        //Set all to defaults
        productId: "",
        basic_details:{
          subtitle: "",
          show_subtitle: true,
          stock_message:"",
          options: {
            show_status_tag: true,
            show_rating_stars: false,
            show_whishing_btn: false,
            show_fullscreen_btn: false,
            autoplay_gallery: false,
            show_qty_colour: false,
            show_stock_message: true,
          }
        },
        feature_panel:{
          show: true,
          content:""
        },
        technical_details_panel:{
          show: true,
          content:""
        },
        review_panel:{
          show: true,
          show_rating_breakdown: true,
          show_product_recomendation_subpanel: true,
          show_write_btn: true,
          show_helpful_line: true
        }
      },
      ituColumns: [
        { name: 'barcode', label: 'Barcode', align: 'center', field: "barcode", sortable: true },
        { name: 'type', label: 'Type', align: 'center', field: "type", sortable: true },
        { name: 'status', label: 'Status', align: 'center', field: "status", sortable: true },
        { name: 'paidprice', label: 'P.P.', align: 'center', field: "paidPrice", sortable: true },
        { name: 'weight', label: 'Weight', align: 'center', field: "weight", sortable: true },
        { name: 'createdAt', label: 'Created', align: 'center', field: "createdAt", sortable: true },
        { name: 'updatedAt', label: 'Updated', align: 'center', field: "updatedAt", sortable: true },
        { name: 'actions', label: 'Actions', align: 'center', field: "action", sortable: true },
      ],      
      skuColumns: [
        { name: 'add', label: ''},
        { name: 'colour', label: 'Colour', align: 'left', field: row => row.options?.colour, sortable: true },
        { name: 'price', label: 'Stock Price', align: 'right', field: 'price', sortable: true, format: formatCurrency },
        { name: 'containerPrice', label: 'Container Price', align: 'right', field: 'containerPrice', sortable: true, format: formatCurrency },
        { name: 'retailPrice', label: 'Retail Price', align: 'right', field: 'retailPrice', sortable: true, format: formatCurrency },
        { name: 'stock', label: 'Stock', align: 'right', field: 'stock', sortable: true },
        { name: 'showInContainer', label: 'Show In Container', align: 'center', field: 'showInContainer', sortable: true },
        { name: 'showInRetail', label: 'Show In Retail', align: 'center', field: row => row.showInRetail || false, sortable: true },
        { name: 'hideInStock', label: 'Hide In Stock', align: 'center', field: row => row.hideInStock || false, sortable: true },
        { name: 'showPreStock', label: 'Show Pre-Stock', align: 'center', field: row => row.showPreStock || false, sortable: true },
        { name: 'preStock', label: 'Pre-Stock', align: 'center', field: row => row.preStock || false, sortable: true },
        { name: 'availableOn', label: 'Available On', align: 'center', field: row => row.availableOn || false, sortable: true },
        { name: 'deleted', label: 'Status', align: 'center', field: row => row.deleted || false, sortable: true },        
        { name: 'actions', label: '', align: 'center', sortable: false }
        // { name: 'Cost Per Hold', label: 'Cost Per Hold', align: 'right', field: row => row.costPerHold, sortable: false, format: formatCurrency }
      ]
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    filteredSkus () {
      return this.product?.skus?.filter?.(sku => JSON.stringify(sku?.options?.colour)?.toLowerCase()?.includes?.(this.skuFilter.toLowerCase()))
    },
    previewFeatures: function() {
      return {
        template: this.productDetails.feature_panel.content
      }
    },
    previewTechnicalDetails: function() {
      return {
        template: this.productDetails.technical_details_panel.content
      }
    }
  },
  methods: {
    async updateAttribute(value){
      console.log("updateAttribute",value)
        let id = this.id;
        let input = {
          name:"Category",
          value
        }

        await this.$apollo.mutate({
          mutation: gql`mutation editAttribute ($id: ID,$input:ProductAttribute) {
            editAttribute(id:$id, input: $input)
          }
          `,
          variables: {
            id:id,
            input: input
          }
        })

        await this.$apollo.queries.product.refetch()

    },
    formatBarcode(bc){
      let zeros = "00000000";
      let padding = zeros.substring(0,8 - bc.length);
      this.newBarcode = padding + bc;
    },
    hiddingSet(){
            console.log('SHOWUING out');

      this.showing = false;
    },
    showingSet(v){
      this.showing = true;
      console.log('SHOWUING SET');
      
    },
    updateType(row){
      this.updateItu_mutation(row.id, {type:row.type}); 
    },
    updateBarcode(row,newBarcode){
      this.updateItu_mutation(row.id, {barcode:newBarcode}); 
    },    
    updateStatus(row){
      console.log("called")
      console.log(row);
      this.updateItu_mutation(row.id, {status:row.status}); 
    },
    async addITU(){
        let skuId = this.selectedSKU.id;
        let input = {};
        if(this.newBarcode != '') input.barcode = this.newBarcode;
        if(this.newPaidPrice != '') input.paidPrice  = Number(this.newPaidPrice);
        if(this.newType != '') input.type  = this.newType;
        if(this.newStatus != '') input.status  = this.newStatus;
        if(this.newWeight != '') input.weight  = Number(this.newWeight);
        await this.addItu_mutation(skuId,input);

        if(this.addQty || this. setForSale){

          let skuInput = {}

          if(this.addQty){
            skuInput.stock = this.selectedSKU.stock + 1;
          }

          if(this. setForSale){
            skuInput.showInRetail = true,
            skuInput.hideInStock = false
          }

          await this.editSku(skuId,skuInput);

        }
    },
    async addItu_mutation (skuId,input){
      this.addITUerror = "";
      try{
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation addItu($skuId: ID!, $input: ItuInput) {
              addItu(skuId: $skuId, input: $input){
                id
                barcode
                paidPrice
                type
                status
                weight
                updatedAt
                createdAt
                deleted
              }
            }
          `,
          variables:{
            skuId: skuId,
            input: input
          }
        })
        await this.$apollo.queries.product.refetch()
      }catch(e){
        this.addITUerror = e;
      } 
    },        
    dialogCreateITU(row){
      this.selectedSKU = row;
      console.log(this.selectedSKU)
      this.showCreateITU = true;
    }, 
    async uploaderFactory (files) {
      if (!files || !files.length) return
      try {
        let result = await this.$apollo.mutate({
          mutation: gql`mutation uploadProductImage ($image: Upload!, $path: String) {
            uploadProductImage(image: $image, path: $path)
          }
        `,
          variables: {
            image: files[0],
            path: this.product?.attributes?.brand
          },
          update: (store, response) => {
            this.newImageDialogShowing = false
            return response
          }
        })
        await this.addNewImage(result.data.uploadProductImage)
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to upload image.', error)
        this.newImageDialogShowing = false
      }
    },
    async addNewImage (imagePath) {
      try {
        let newImages = this.product.images.slice(0).map(img => {
          delete img['__typename']
          return img
        })
        newImages.push({
          name: null,
          url: imagePath
        })
        await this.$apollo.mutate({
          mutation: gql`mutation editProduct ($id: ID!, $input: ProductInput!) {
            editProduct(id: $id, input: $input) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInRetail
                showInContainer
                showPreStock
                preStock
                availableOn                
                hideInStock
                stock
              }
            }
          }
        `,
          variables: {
            id: this.id,
            input: {
              images: newImages
            }
          }
        })
        this.newImageDialogShowing = false
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to upload image.', error)
        this.newImageDialogShowing = false
      }
    },
    editSkuColour (sku) {
      this.$q.dialog({
        component: ColourSelectDialog
      }).onOk((value) => {
        this.editSku(sku.id, { options: { colour: JSON.stringify(value) } })
      })
    },
    createNewSkuColour (sku) {
      this.$q.dialog({
        title: 'Enter a JSON object to be a new colour',
        cancel: true,
        prompt: {
          model: JSON.stringify(sku.options.colour),
          type: 'text'
        }
      }).onOk((value) => {
        this.editSku(sku.id, { options: { colour: value } })
      })
    },
    async editAllSkus (changes) {
      if (this.skuFilter) {
        this.$q.dialog({
          title: 'Could not write.',
          description: 'You must first clear the sku filter here in the sku section.',
          cancel: true
        })
        return
      }
      const promises = []
      this.product.skus.forEach((sku) => {
        promises.push(this.editSku(sku.id, changes))
      })
      await Promise.all(promises)
    },
    async editSku (skuId, changes) {
      // {"operationName":"editSku","variables":{"id":"5de9a8e5017f7816e4052045","input":{"stock":1}},"query":"mutation editSku($id: ID!, $input: SkuInput!) {\n  editSku(id: $id, input: $input) {\n    id\n    stock\n    __typename\n  }\n}\n"}
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation editSku ($id: ID!, $input: SkuInput!) {
            editSku(id: $id, input: $input) {
              id
              attributes
              barcode
              options
              price
              containerPrice
              retailPrice
              showInContainer
              showPreStock
              preStock
              availableOn              
              showInRetail
              hideInStock
              stock
            }
          }
        `,
          variables: {
            id: skuId,
            input: changes
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to edit sku.', error)
      }
    },
    async deleteImage (imageUrl) {
      this.$q.dialog({
        title: 'Delete Order',
        message: `Are you sure you want to delete this image?`,
        cancel: true
      }).onOk(() => {
        this.deleteImageWithoutAsking(imageUrl)
      })
    },
    async deleteImageWithoutAsking (imageUrl) {
      try {
        let newImages = this.product.images.slice(0)
          .filter(img => img.url !== imageUrl)
          .map(img => {
            delete img['__typename']
            return img
          })
        await this.$apollo.mutate({
          mutation: gql`mutation editProduct ($id: ID!, $input: ProductInput!) {
            editProduct(id: $id, input: $input) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInRetail
                showInContainer
                showPreStock
                preStock
                availableOn                
                hideInStock
                stock
              }
            }
          }
        `,
          variables: {
            id: this.id,
            input: {
              images: newImages
            }
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to upload image.', error)
        this.newImageDialogShowing = false
      }
    },
    async updateImage (imageUrl, newUrl) {
      try {
        let newImages = this.product.images.slice(0)
          .map(img => {
            delete img['__typename']
            return img
          })
        let imageToEdit = newImages.find(img => img.url === imageUrl)
        if (!imageToEdit) throw new Error(`Could Not Find Image to edit with url ${imageUrl}.`)
        imageToEdit.url = newUrl
        await this.$apollo.mutate({
          mutation: gql`mutation editProduct ($id: ID!, $input: ProductInput!) {
            editProduct(id: $id, input: $input) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInRetail
                showInContainer
                showPreStock
                preStock
                availableOn                
                hideInStock
                stock
              }
            }
          }
        `,
          variables: {
            id: this.id,
            input: {
              images: newImages
            }
          }
        })
      } catch (error) {
        adminNotifyError(this.$q, 'Failed to upload image.', error)
        this.newImageDialogShowing = false
      }
    },
    async deleteSku (sku) {
      this.$q.dialog({
        title: 'Delete Sku',
        message: `Are you sure you want to delete this sku?  You should only delete skus if you JUST created it accidentally.  Otherwise you can corrupt orders that contain this sku.`,
        cancel: true
      }).onOk(async () => {
        try {
          await this.$apollo.mutate({
            mutation: gql`
              mutation deleteSku($id: ID!) {
                  deleteSku (id: $id)
              }
            `,
            variables: {
              id: sku.id
            }
          })
          await this.$apollo.queries.product.refetch()
        } catch (error) {

          this.$q.notify({
            message: `Error deleting Sku! ${error.message}`,
            color: 'negative',
            icon: 'report_problem'
          })
        }
      })
    },
    async addSku (row) {
      try {
        const input = {
          productId: this.id,
          price: 0,
          stock: 0,
          barcode: '',
          attributes: [],
          options: {
            colour: JSON.stringify({ 'name': '07-13', 'superGroup': 'Purple', 'group': 'Purple', 'hex': '#800f7f' })
          }
        }
        await this.$apollo.mutate({
          mutation: gql`
            mutation addSku($input: SkuInput!) {
                addSku (input: $input) { id }
            }
          `,
          variables: {
            input
          }
        })
        await this.$apollo.queries.product.refetch()
      } catch (error) {
        this.$q.notify({
          message: `Error adding Sku! ${error.message}`,
          color: 'negative',
          icon: 'report_problem'
        })
      }
      this.validateRow(row)
    },
    async updatePD(){
      let productId = this.product.id;
      let result = await this.updateProductDetails_mutation(productId, this.productDetails);
    },     
    async addPD(){
      this.productDetails.productId = this.product.id;
      let result = await this.addProductDetails_mutation(this.productDetails);
    },    
    async addProductDetails_mutation(input){      
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation addProductDetails ($input: ProductDetailsInput!) {
            addProductDetails(input: $input) {
                id
                productId
                basic_details {
                    subtitle
                    show_subtitle
                    options
                }
                feature_panel {
                    show
                    content
                }
                technical_details_panel{
                    show
                    content
                }
                review_panel{
                    show
                    show_rating_breakdown
                    show_product_recomendation_subpanel
                    show_write_btn
                    show_helpful_line
                }
            }
          }
        `,
          variables: {
            input: input
          }
        })
        if(result.data.addProductDetails){
          this.$q.notify({
            message: "Product Details Created!",
            color: 'positive',
            icon: 'done'
          })
        }
        return result.data.addProductDetails;
      } catch (error) {
        this.$q.notify({
          message: `Error adding product details: ${error.message}`,
          color: 'negative',
          icon: 'report_problem'
        })
        throw new Error(error);
      }
    },
    async updateProductDetails_mutation(productId,input){

      try {
        delete input.id;
        const result = await this.$apollo.mutate({
          mutation: gql`mutation updateProductDetails ($productId: ID, $input: ProductDetailsInput!) {
            updateProductDetails(productId:$productId, input: $input) {
                id
                productId
                basic_details {
                    subtitle
                    show_subtitle
                    options
                }
                feature_panel {
                    show
                    content
                }
                technical_details_panel{
                    show
                    content
                }
                review_panel{
                    show
                    show_rating_breakdown
                    show_product_recomendation_subpanel
                    show_write_btn
                    show_helpful_line
                }
            }
          }
        `,
          variables: {
            productId,
            input
          }
        })
        if(result.data.updateProductDetails){
          this.$q.notify({
            message: "Product Details Updated!",
            color: 'positive',
            icon: 'done'
          })
        }
        return result.data.updateProductDetails;
      } catch (error) {
        this.$q.notify({
          message: `Error updating product details: ${error.message}`,
          color: 'negative',
          icon: 'report_problem'
        })
        throw new Error(error);
      }
    },    
    async getPD(){
        let id = this.id
        let result = await this.getProductDetails_query(id)
        if(result.id){
          this.productDetails = Object.assign(this.productDetails,result);
          this.pdLoaded = true
        }
    },
    async getProductDetails_query(id){
      try {
        const result = await this.$apollo.query({
          query: gql`query productDetails ($id: ID!) {
            productDetails (id: $id) {
                id
                productId
                basic_details {
                    subtitle
                    show_subtitle
                    stock_message
                    options
                }
                feature_panel {
                    show
                    content
                }
                technical_details_panel{
                    show
                    content
                }
                review_panel{
                    show
                    show_rating_breakdown
                    show_product_recomendation_subpanel
                    show_write_btn
                    show_helpful_line
                }
            }
          }
        `,
        variables: {
          id: id
        },         
        fetchPolicy: 'network-only'
        })
        const omitTypename = (key, value) => (key === '__typename' ? undefined : value)
        const newPayload = JSON.parse(JSON.stringify(result.data.productDetails), omitTypename)
        return newPayload;
      } catch (error) {
        throw new Error(error);    
      }      
    },
    async updateItu_mutation (ituId,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation updateItu($ituId: ID!, $input: ItuInput) {
              updateItu(ituId: $ituId, input: $input)
              {
                id
                barcode
                paidPrice
                type
                status
                weight
                updatedAt
                createdAt
                deleted
              }
            }
          `,
          variables:{
            ituId: ituId,
            input: input
          }
        })
    }    
  },
  async mounted(){
    await this.getPD()
  }
}
</script>

<style scoped>

</style>
